import { Component, OnInit, Input, NgZone } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { OrdenService } from 'src/app/services/orden.service';
import { OrdenDetalle } from 'src/app/classes/ordendetalle';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit {

  @Input() item: any;

  detalle: OrdenDetalle[] = [];

  constructor(
    private ordenAPI: OrdenService,
    private zone: NgZone,
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    console.log(this.item);
    const id = this.item.cOrdenFolio;
    this.showHistorial(id);
  }

  toBack() {
    this.modalCtrl.dismiss();
  }

  showHistorial(id: any) {
    this.ordenAPI.getOrdenDetalle(id).then((res: any) => {
      this.zone.run(() => {
        // console.log('Ordenes', res);
        this.detalle = res.data;
      });
    });
  }

}
